import {
  ArrowDownCircle,
  ArrowLeftCircle,
  ArrowRightCircle,
} from 'react-feather'
import { Card, CardText, Col, List, Row } from 'reactstrap'

// css
import { useDispatch, useSelector } from 'react-redux'
import { tags } from 'utils/tags'

import BreadCrumbs from 'components/breadcrumbs'
import { useEffect, useState } from 'react'
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom'
import { URL_PAYMENT_HISTORY, URL_PIUTANG, URL_UTANG } from 'utils/pathUrl'
import { BUSINESS_AR_AP, BUSINESS_AR_AP_COMPANY, BUSINESS_MYAPPROVAL, READ } from 'utils/subjectActions'
import PMBTabSwitcher from 'components/PMBTabSwitcher'
import { useAbilityAccess } from 'hooks/useAbilityAccess'
import { setType } from './payableNotesSlice'

const IndexTabARAP = () => {
  const nav = useNavigate()
  let location = useLocation()
  const dispatch = useDispatch()

  const hasPersonalAbility = useAbilityAccess({ action: READ, subject: BUSINESS_AR_AP })
  const hasCompanyAbility = useAbilityAccess({ action: READ, subject: BUSINESS_AR_AP_COMPANY })
  const showSwitcher = hasPersonalAbility && hasCompanyAbility

  const { countData } = useSelector((s) => s.approval)
  const { type } = useSelector((s) => s.payableNotes)

  const [activeTab, setActiveTab] = useState('ar')

  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey)
    if (tabKey === 'ar') {
      nav(`${URL_PIUTANG}`)
    } else if (tabKey === 'ap') {
      nav(`${URL_UTANG}`)
    } else {
      nav(`${URL_PAYMENT_HISTORY}`)
    }
  }

  useEffect(() => {
    if (location?.pathname === `${URL_PIUTANG}`) {
      setActiveTab('ar')
    } else if (location?.pathname === `${URL_UTANG}`) {
      setActiveTab('ap')
    } else {
      setActiveTab('history')
    }
  }, [location])

  return (
    <div className="w-100 px-3 pb-3">
      <div className="d-flex align-items-start gap-2 pt-3">
        <BreadCrumbs breadCrumbActive={'Manajemen Utang Piutang'} />
      </div>
      <Card body className="border-0 shadow-sm">
        <div className='d-flex align-items-center gap-3'>
          <CardText tag="h5" className="pb-2 py-2">
            Manajemen Utang Piutang
          </CardText>
          {showSwitcher && (
            <div className="d-flex bg-light rounded p-1 border">
              <div
                className={`px-3 py-1 rounded ${type !== 'personal' ? 'bg-white shadow-sm fw-bold text-primary' : 'text-muted'}`}
                style={{ cursor: 'pointer', transition: 'all 0.2s', fontSize: '14px' }}
                onClick={() => dispatch(setType('company'))}
              >
                Perusahaan
              </div>
              <div
                className={`px-3 py-1 rounded ${type === 'personal' ? 'bg-white shadow-sm fw-bold text-primary' : 'text-muted'}`}
                style={{ cursor: 'pointer', transition: 'all 0.2s', fontSize: '14px' }}
                onClick={() => dispatch(setType('personal'))}
              >
                Personal
              </div>
            </div>
          )}
        </div>

        <div className="mb-2 d-flex justify-content-start">
          <PMBTabSwitcher
            activeTab={activeTab}
            tabs={[
              {
                key: 'ap',
                label: `Utang`,
              },
              {
                key: 'ar',
                label: `Piutang`,
              },
              {
                key: 'history',
                label: `Riwayat Pembayaran`,
              },
            ]}
            onTabChange={handleTabChange}
          />
        </div>
        <Outlet />
      </Card>
    </div>
  )
}

export default IndexTabARAP
